/* generated by gulpfile.js */
/*eslint camelcase: 0 */
import ArithmeticMean from '../collectors/number/ArithmeticMean';
import Count from '../collectors/number/Count';
import FilteredCount from '../collectors/number/FilteredCount';
import GeometricMean from '../collectors/number/GeometricMean';
import HarmonicMean from '../collectors/number/HarmonicMean';
import Max from '../collectors/number/Max';
import Mean from '../collectors/number/Mean';
import Median from '../collectors/number/Median';
import MidRange from '../collectors/number/MidRange';
import Min from '../collectors/number/Min';
import PowerSumAvgRunning from '../collectors/number/PowerSumAvgRunning';
import Product from '../collectors/number/Product';
import Range from '../collectors/number/Range';
import StandardDeviationRunning from '../collectors/number/StandardDeviationRunning';
import StandardDeviationStable from '../collectors/number/StandardDeviationStable';
import Sum from '../collectors/number/Sum';
import SumOfRecipricals from '../collectors/number/SumOfRecipricals';
import SumOfSquaredDeviationsStable from '../collectors/number/SumOfSquaredDeviationsStable';
import Values from '../collectors/number/Values';
import ValuesSorted from '../collectors/number/ValuesSorted';
import VarianceRunning from '../collectors/number/VarianceRunning';
import VarianceStable from '../collectors/number/VarianceStable';
export {
  ArithmeticMean,
  Count,
  FilteredCount,
  GeometricMean,
  HarmonicMean,
  Max,
  Mean,
  Median,
  MidRange,
  Min,
  PowerSumAvgRunning,
  Product,
  Range,
  StandardDeviationRunning,
  StandardDeviationStable,
  Sum,
  SumOfRecipricals,
  SumOfSquaredDeviationsStable,
  Values,
  ValuesSorted,
  VarianceRunning,
  VarianceStable
};
